import React, { SyntheticEvent, useCallback, useContext } from "react";
import styles from './previewLayer.module.scss';
import { checkConfigurationTypeRotationAvailable } from "@susu/custom-made/utils/utils";
import cn from 'classnames';
import { ConfigurationTypes } from "@susu/custom-made/utils/productDefinition";
import { LayerDefinition } from "@susu/custom-made/utils/preview/layers";
import PreviewRotationLayer from "./previewRotationLayer";
import { ThemeContext } from "@susu/custom-made/providers";

const PreviewOtherLayers = React.memo(({
  layers,
  updateFailedLayers,
  configurationType,
}: Readonly<{
  layers: LayerDefinition[];
  updateFailedLayers?: (layer: string) => void;
  configurationType?: ConfigurationTypes;
}>) => {
  const { state } = useContext(ThemeContext);
  
  const onLayerFailed = useCallback(
    (e: SyntheticEvent<HTMLImageElement, Event>) => {
      if (updateFailedLayers) {
        updateFailedLayers(e.currentTarget.src);
      }
      e.currentTarget.style.display = 'none';
    },
    [updateFailedLayers],
  );

  const onLayerLoad = (e: SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.style.display = 'block';
  };

  return [...layers].splice(1).map((layer, index) => (
    <React.Fragment key={`otherlayerContainer_${index}`}>
      {checkConfigurationTypeRotationAvailable(configurationType, state.growthbookFeatures['show-3D-preview-image']) && (
        <PreviewRotationLayer
          layer={layer}
          index={index}
          keyPrefix="otherlayer"
          onLayerFailed={onLayerFailed}
          onLayerLoaded={onLayerLoad}
        />
      )}
      {!checkConfigurationTypeRotationAvailable(configurationType, state.growthbookFeatures['show-3D-preview-image']) && (
        <div className={cn(styles.layer, styles.isActive)}>
          <img
            src={layer.src}
            srcSet={layer.srcset}
            alt={`otherlayer_${index}`}
            onError={onLayerFailed}
            onLoad={onLayerLoad}
            sizes={layer.sizes}
            fetchPriority="high"
            loading="eager"
          />
        </div>
      )}
    </React.Fragment>
  ));
});

export default PreviewOtherLayers;